<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import axios from "axios";
import loadingVue from "@/components/loading.vue";
// import Carousel from "vue-owl-carousel";

/**
 * Starter page
 */
export default {
  components: {
    Layout,
    loadingVue,
    // Carousel,
  },
  page: {
    title: "Student",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "CBT - Siswa",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Student",
          active: true,
        },
      ],
      isLoading: true,
      setRespv: null,
      setPaketSoal: [],
      setListPaketSoal: null,
      setDataSearch: [],
      selectedFilter: null,
      selected: null,
      options: [
        { value: null, text: "Pilih Jenis Paket", disabled: true },
        { value: "", text: "Semua" },
        { value: "1", text: "Ujian" },
        { value: "0", text: "Latihan/TryOut" },
      ],
      errorMessage: false,
    };
  },
  mounted() {
    this.getListPaketSoal();
    this.getPaketSoal();
  },
  computed: {
    filteredData() {
      if (!this.selectedFilter) {
        return this.setPaketSoal;
      } else {
        const isUjian = parseInt(this.selectedFilter);
        return this.setPaketSoal.filter((item) => {
          return item.soal.is_ujian === isUjian;
        });
      }
    },
    filteredItem() {
      if (!this.selectedFilter) {
        return this.setListPaketSoal;
      } else {
        return this.setListPaketSoal.filter((data) => {
          return this.filteredData.some((data2) => {
            return data2.id_paket_soal === data.id_paket_soal;
          });
        });
      }
    },
  },

  methods: {
    async getPaketSoal() {
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/api/json/get-distribusi-soal")
        .then((response) => {
          this.setPaketSoal = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            this.errorMessage = true;
            this.isLoading = false;
          }
        });
    },

    async getListPaketSoal() {
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/api/json/get-list-soal")
        .then((response) => {
          response.data.forEach((data) => {
            this.setDataSearch.push(data.paket_soal);
          });
          return (this.setListPaketSoal = response.data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            this.errorMessage = true;
            this.isLoading = false;
          }
        });
    },
    testFunc(e) {
      console.log(e);
    },
  },
  middleware: "authentication",
};
</script>
<style scoped>
.bg-custom {
  background-color: var(--bs-indigo);
}
.border-custom {
  border-color: #adb5bd !important;
}
.custom-select {
  padding: 0.75rem !important;
  font-size: 1rem !important;
}
</style>
<style></style>
<template>
  <Layout>
    <div v-if="errorMessage" class="alert alert-danger" role="alert">
      <h1 align="center">
        Anda tidak mempunyai akses pada halaman ini, Silahkan Klik dibawah ini.
      </h1>
    </div>
    <div v-if="errorMessage" class="logout w-25 mx-auto" align="center">
      <a class="dropdown-item" href="/logout">
        <i
          class="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"
        ></i>
        <span class="align-middle">{{
          $t("navbar.dropdown.marcus.list.logout")
        }}</span>
      </a>
    </div>

    <div v-if="isLoading !== true">
      <div class="mt-3 mb-3">
        <b-row>
          <template v-for="dataBody in filteredData">
            <b-col
              sm="4"
              md="4"
              lg="3"
              v-if="dataBody.id_paket_soal"
              :key="dataBody.id"
            >
              <div v-if="dataBody.is_answered && dataBody.is_finished">
                <b-link :href="'/student/ujian/detail/' + dataBody.id_soal">
                  <div class="card">
                    <b-row>
                      <b-col>
                        <img
                          :src="'/img-package/' + dataBody.soal.paket + '.jpg'"
                          class="card-img-top"
                          :alt="'Gambar Paket ' + dataBody.soal.paket"
                        />
                        <span class="soal-id top-right"
                          >Soal ID {{ dataBody.soal.id }}</span
                        >
                      </b-col>
                    </b-row>
                    <div class="card-body border-3 rounded-3">
                      <template>
                        <!-- <h5 class="border-2 border-top border-custom pt-2">
                          <span>Nama Test : {{ dataBody.soal.paket }}</span>
                        </h5> -->
                        <b-row>
                          <b-col md="12">
                            <span class="soal-id"
                              >Paket Soal {{ dataBody.paket_soal.name }}</span
                            >
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col md="7">
                            <p class="m-0 fs-6 text-muted">
                              <strong>Jumlah Soal</strong>:
                              {{ dataBody.length_soal }}
                            </p>
                          </b-col>
                          <b-col md="5" class="text-end">
                            <p class="my-1 fs-6 text-muted">
                              <i class="fa fa-clock"></i>
                              {{ dataBody.soal.waktu }} Menit
                            </p>
                          </b-col>
                        </b-row>
                        <b-card-footer
                          class="text-center text-light btn-purple rounded mt-3"
                          style="font-size: 16px;"
                        >
                          Mulai Ujian
                        </b-card-footer>
                      </template>
                    </div>
                  </div>
                </b-link>
              </div>

              <div v-else>
                <b-link :href="'/scores'">
                  <div class="card">
                    <b-row>
                      <b-col>
                        <img
                          :src="'/img-package/' + dataBody.soal.paket + '.jpg'"
                          class="card-img-top"
                          :alt="'Gambar Paket ' + dataBody.soal.paket"
                        />
                        <span class="soal-id top-right"
                          >Soal ID {{ dataBody.soal.id }}</span
                        >
                      </b-col>
                    </b-row>
                    <div class="card-body border-3 rounded-3">
                      <b-row>
                        <b-col md="12">
                          <span class="soal-id"
                            >Paket Soal {{ dataBody.paket_soal.name }}</span
                          >
                        </b-col>
                      </b-row>
                      <b-row class="mt-3">
                        <b-col md="7">
                          <p class="m-0 fs-6 text-muted">
                            <strong>Jumlah Soal</strong>:
                            {{ dataBody.length_soal }}
                          </p>
                        </b-col>
                        <b-col md="5" class="text-end">
                          <p class="my-1 fs-6 text-muted">
                            <i class="fa fa-clock"></i>
                            {{ dataBody.soal.waktu }} Menit
                          </p>
                        </b-col>
                      </b-row>

                      <b-card-footer
                        class="text-center btn-outline-purple purple mt-3"
                      >
                        Lihat Nilai
                      </b-card-footer>
                      <!-- <h5 class="border-2 border-top border-custom pt-2">
                        <span>Nama Test : {{ dataBody.soal.paket }}</span>
                      </h5> -->
                    </div>
                  </div>
                </b-link>
              </div>
            </b-col>
          </template>
        </b-row>
      </div>
    </div>

    <div
      style="height: 74vh;"
      class="d-flex justify-content-center align-items-center"
      v-else
    >
      <loading-vue></loading-vue>
    </div>
  </Layout>
</template>
